import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonModes } from '@hallmark/web.core.buttons.button';
import { removeBeforeUnloadEvent } from '../../../utils';
import { ActionButtonProps } from '../system-failure-dialog-types';

export const ActionButton = ({ click }: ActionButtonProps): React.ReactElement => {
  const { t } = useTranslation();

  const onClick = () => {
    removeBeforeUnloadEvent();
    click();
  };

  return (
    <Button click={onClick} mode={ButtonModes.Primary} testId="action-button">
      {t('systemFailureDialog.action')}
    </Button>
  );
};
